/* POD Client barrel export */

import { IPodClient } from './IPodClient';
import { PodClientApi } from './podClientApi';
import { PodClientMocked } from './podClientMocked';

// Re-export types
export * from './podTypes';
export * from './IPodClient';

/* ---- Configuration ---- */

import { shouldUseMockedClient } from '../../environment';

/**
 * Determines whether to use mocked clients.
 * Automatically uses mocked clients on localhost and ofstest5 environments.
 */
const isMockedEnvironment = () => shouldUseMockedClient();

/* ---- Factory Function ---- */

let podClientInstance: IPodClient | null = null;

/**
 * Get the PodClient instance.
 * Automatically uses mocked data on localhost and ofstest5 environments.
 */
export function getPodClient(): IPodClient {
  if (podClientInstance) {
    return podClientInstance;
  }

  if (isMockedEnvironment()) {
    podClientInstance = new PodClientMocked();
  } else {
    podClientInstance = PodClientApi.getInstance();
  }

  return podClientInstance;
}

/**
 * Reset the client instance (useful for testing)
 */
export function resetPodClient(): void {
  podClientInstance = null;
}

/**
 * POD client singleton instance.
 * Automatically uses mocked data on localhost and ofstest5 environments.
 */
export const podClient = getPodClient();

// Log which client is being used for debugging
console.log(`[PodClient] Using ${isMockedEnvironment() ? 'MOCKED' : 'REAL'} client on ${typeof window !== 'undefined' ? window.location.hostname : 'server'}`);
console.log('[PodClient] Client instance:', podClient.constructor.name);
